<template>
  <CustomLink
    :text="text"
    :type="isPrimary ? LINK_TYPE.Primary : LINK_TYPE.NoStyle"
    :url="url"
    @link-click="toggleNavigation()"
  />
</template>

<script lang="ts">


import { LINK_TYPE } from '~~/types/components/Link/LinkType';

export default defineComponent({
  name: 'NavigationLink',

  props: {
    isPrimary: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  setup () {

    const { toggleNavigation } = useNavigationState();

    return {
      toggleNavigation,
      LINK_TYPE,
    };
  
  },
});

</script>
